import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";

const BranchCreate = ({ permission }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [formData, setFormData] = useState({
    branch_code: "",
    branch_name: "",
    address: "",
    city: "",
    state: "",
    district: "",
    pincode: "",
    phone: "",
    email: "",
    branch_manager_name: "",
    branch_manager: "",
    branch_manager_contact: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [citydata, setCityData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    const stateData = await fetchData("active-states", {}, "POST");
    const userData = await fetchFormData("user/list", formData, "POST");

    if (stateData) {
      const states = stateData.states;
      setStateData(getValueLabel(states, "state_title", "state_id") || []);
    }

    if (userData) {
      const states = userData.users;
      const formattedUserData = states.map((user) => ({
        value: user.id,
        label: `${user.name} (${user.phone}) - ${user.role}`,
        name: user.name,
        phone: user.phone,
      }));

      setUserData(formattedUserData);
    }
  };

  const fetchDistrictData = async (stateId) => {
    const result = await fetchData(`districts/${stateId}`, {}, "POST");

    if (result) {
      const districts = result.districts;
      setDistrictData(
        getValueLabel(districts, "district_title", "district_id") || []
      );
    }
  };
  const fetchCityData = async (districtId) => {
    const result = await fetchData(`cities/${districtId}`, {}, "POST");

    if (result) {
      const cities = result.cities;
      setCityData(getValueLabel(cities, "city_title", "city_id") || []);
    }
  };
  const handleStateChange = (option) => {
    setFormData((prevData) => ({
      ...prevData,
      state: option.value,
      district: "",
      city: "",
    }));
    setDistrictData([]);
    setCityData([]);
    fetchDistrictData(option.value);
  };
  const handleDistrictChange = (option) => {
    setFormData((prevData) => ({
      ...prevData,
      district: option.value,
      city: "",
    }));
    setCityData([]);
    fetchCityData(option.value);
  };
  const handleCityChange = (option) => {
    if (option?.value) {
      setFormData((prev) => ({
        ...prev,
        city: option.value,
      }));
    }
  };
  const handleUserChange = (option) => {
    if (option) {
      setFormData((prev) => ({
        ...prev,
        branch_manager: option.value,
        branch_manager_name: option.name,
        branch_manager_contact: option.phone,
      }));
    }
  };
  const fetchDetails = async (id) => {
    try {
      const result = await fetchData(`branch/details/${id}`, {}, "POST");

      if (result && result.branch) {
        setFormData(result.branch);
        fetchDistrictData(result.branch.state);
        fetchCityData(result.branch.district);
      } else {
        console.warn("User data not found.");
        setFormData("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setFormData("");
    }
  };

  useEffect(() => {
    fetchAllData();
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  useEffect(() => {
    if (userData.length > 0 && formData.branch_manager_name) {
      const branchManager = userData.find(
        (user) => user.name === formData.branch_manager_name
      );

      if (branchManager) {
        setFormData((prev) => ({
          ...prev,
          branch_manager: branchManager.value,
          branch_manager_name: branchManager.name,
          branch_manager_contact: branchManager.phone,
        }));
      } else {
        console.log("Branch manager not found in user data.");
      }
    }
  }, [userData, formData.branch_manager_name]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formPayload = new FormData();

    formPayload.append("created_by", userId);
    formPayload.append("moduleId", M_id);
    formPayload.append("branchID", 1);
    formPayload.append("branch_code", formData.branch_code);
    formPayload.append("branch_name", formData.branch_name);
    formPayload.append("address", formData.address);
    formPayload.append("city", formData.city);
    formPayload.append("state", formData.state);
    formPayload.append("district", formData.district);
    formPayload.append("pincode", formData.pincode);
    formPayload.append("phone", formData.phone || "");
    formPayload.append("email", formData.email);
    formPayload.append("branch_manager_name", formData.branch_manager_name);
    formPayload.append(
      "branch_manager_contact",
      formData.branch_manager_contact
    );

    try {
      let res;

      if (id) {
        formPayload.append("userId", userId);

        res = await fetchFormData(`branch/update/${id}`, formPayload, "POST");
        console.log("Updating branch:", id, formData);
      } else {

        res = await fetchFormData("branch/create", formPayload, "POST");
        console.log("Creating new branch:", formData);
      }

      if (res && res.code === 200) {
        navigate(`/master/branch-list?id=${M_id}`);
        topTost({
          title: res.message,
          icon: "success",
        });
      } else if (res && res.code === 422) {
        topTost({
          title: Array.isArray(res.message)
            ? res.message
            : res.message || "Validation error",
          icon: "error",
        });
      } else {
        console.error("Branch operation failed", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Company Branch:" : "Add Company Branch:"}
                </span>
              </h5>
            </div>
            <form onSubmit={handleSubmit}>
              {/* Branch Code + Branch Name */}
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Branch Code"
                    name="branch_code"
                    value={formData.branch_code}
                    onChange={handleChange}
                    placeholder="Branch Code"
                    icon="feather-hash"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Branch Name"
                    name="branch_name"
                    value={formData.branch_name}
                    onChange={handleChange}
                    placeholder="Company Branch Name"
                    icon="feather-home"
                    required
                  />
                </div>
              </div>

              {/* Address + Pincode */}
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Address"
                    icon="feather-map-pin"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Pincode"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    placeholder="Pincode"
                    icon="feather-hash"
                  />
                </div>
              </div>

              {/* Phone + Email */}
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Phone"
                    name="phone"
                    value={formData.phone || ""}
                    onChange={handleChange}
                    placeholder="Phone"
                    icon="feather-phone"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    icon="feather-mail"
                  />
                </div>
              </div>

              {/* State + District Dropdowns */}
              <div className="row mb-4 align-items-center">
                <div className="col-lg-2">
                  <label className="fw-semibold">
                    State:
                    <span className="text-danger px-1">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={stateData}
                    selectedOption={
                      stateData.find(
                        (opt) => opt.value === Number(formData.state)
                      ) || ""
                    }
                    defaultSelect="Select State"
                    value={Number(formData.state)}
                    onSelectOption={handleStateChange}
                    icon="feather-map-pin"
                    required={true}
                  />
                </div>

                <div className="col-lg-2">
                  <label className="fw-semibold">
                    District:
                    <span className="text-danger px-1">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={districtData}
                    value={Number(formData.district)}
                    selectedOption={
                      districtData.find(
                        (opt) => opt.value === Number(formData.district)
                      ) || ""
                    }
                    defaultSelect="Select District"
                    onSelectOption={handleDistrictChange}
                    icon="feather-layers"
                    required={true}
                  />
                </div>
              </div>

              {/* City + Branch Manager Dropdowns */}
              <div className="row mb-4 align-items-center">
                <div className="col-lg-2">
                  <label className="fw-semibold">
                    City: <span className="text-danger px-1">*</span>{" "}
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={citydata}
                    value={Number(formData.city)}
                    selectedOption={
                      citydata.find(
                        (opt) => opt.value === Number(formData.city)
                      ) || ""
                    }
                    defaultSelect="Select City"
                    onSelectOption={handleCityChange}
                    icon="feather-flag"
                    required={true}
                  />
                </div>

                <div className="col-lg-2">
                  <label className="fw-semibold">Branch Manager:</label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={userData}
                    name="branch_manager"
                    value={Number(formData.branch_manager)}
                    selectedOption={
                      userData.find(
                        (opt) => opt.label === formData.branch_manager
                      ) || ""
                    }
                    defaultSelect="Select Manager"
                    onSelectOption={handleUserChange}
                    icon="feather-user"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BranchCreate;
